import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import keycloakReducer from "./keycloak/keycloakReducer";
import gestionContratReducer from "./gestionContrat/gestionContratReducer";
import resourcesReducer from "./resources/resourcesReducer"

const saveToLocalStorage = (state) => {
    try {
        localStorage.setItem('state', JSON?.stringify(state));
    } catch (e) {
        console.error(e);
    }
};

const loadFromLocalStorage = () => {
    try {
        const stateStr = localStorage.getItem('state');
        return stateStr ? JSON.parse(stateStr) : undefined;
    } catch (e) {
        console.error(e);
        return undefined;
    }
};

const rootReducer = {
    gestionContratReducer,
    keycloakReducer,
    resourcesReducer,
};

const persistedStore = loadFromLocalStorage();

const store = configureStore({
    reducer: rootReducer,
    preloadedState: persistedStore,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
    devTools: process.env.NODE_ENV !== 'production'
});

store.subscribe(() => {
    saveToLocalStorage({
        gestionContratReducer: {
            ...store?.getState()?.gestionContratReducer
        },
        keycloakReducer: {
            ...store?.getState()?.keycloakReducer
        },
        resourcesReducer: {
            ...store?.getState()?.resourcesReducer
        },
    });
});

export default store;